import { IAdminConfig } from '../../interfaces/admin-config.interface'

export interface AdminConfigStateModel {
  config: IAdminConfig
}
